<!--
 * @Author: your name
 * @Date: 2020-06-10 13:48:07
 * @LastEditTime: 2024-03-01 11:38:42
 * @LastEditors: zhouhx
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\views\login\forget-pwd.vue
-->
<template>
  <div class="confirmModal">
    <van-dialog
      v-model="showConfirm"
      :title="msgData.title"
      width="80%" height="145px" style="overflow: auto;"
      show-cancel-button
      @confirm="confirm"
      @cancel="cancel"
    >
    <p class="mainMsg">{{msgData.msg}}</p>
    <span class="warn">{{msgData.warn}}</span>
    <!-- <span slot="footer" class="dialog-footer">
      <button id="save" @click='handleDialogYes'>确 定</button>
      <button id="cancel" @click='handleDialogClose'>取 消</button>
    </span> -->
    </van-dialog>
  </div>
</template>
<script>
export default {
  props: {
    msgData: {
      type: Object,
      default: () => {
        return {
          title: '提示信息',
          msg: '是否确认删除？',
          warn: '删除之后不可恢复'
        }
      }
    },
    dialogState: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showConfirm: false
    };
  },
  created () {},
  methods: {
    cancel (done) {
      this.$emit('changeDialog', 'close')
    },
    confirm (done) {
      this.$emit('changeDialog', 'yes', this.msgData)
    }
  },
  watch: {
    dialogState (val) {
      this.showConfirm = val;
    }
  },
  computed: {},
  components: {}
};
</script>
<style lang="scss" scoped>
.confirmModal {
  // height: 100%;
  // width: 100%;
}
.mainMsg {
  margin: 15px 40px;
}
</style>
